import React from 'react'
import { motion } from 'framer-motion'

export function PurpleTypingIndicatorComponent() {
  return (
    <div className="flex items-center space-x-1" aria-live="polite" aria-busy="true">
      <span className="sr-only">Waiting for input</span>
      {[0, 1, 2].map((dot) => (
        <motion.div
          key={dot}
          className="w-2 h-2 bg-purple-500 rounded-full"
          initial={{ opacity: 0.5 }}
          animate={{ opacity: [0.5, 1, 0.5] }}
          transition={{ duration: 1.5, repeat: Infinity, delay: dot * 0.2 }}
        />
      ))}
    </div>
  )
}